import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Import Constants
import { CustomerJourneyGroupBlockTypes } from 'constants/common';

const { target, action, trigger, condition } = CustomerJourneyGroupBlockTypes;

export interface CustomerJourneySliceState {
    blocksCounts: Record<string, number>;
    maxBlocksCounts: number;
}

const blocksCountsInitialState = {
    [target]: 0,
    [action]: 0,
    [trigger]: 0,
    [condition]: 0,
};

export const initialState: CustomerJourneySliceState = {
    blocksCounts: { ...blocksCountsInitialState },
    maxBlocksCounts: 0,
};

export const customerJourneySlice = createSlice({
    name: 'customerJourney',
    initialState,
    reducers: (create) => ({
        incrementBlockCount: create.reducer((state, { payload }: PayloadAction<Record<string, number>>) => {
            Object.keys(payload).forEach((item) => {
                state.blocksCounts[item] += payload[item];
            });
        }),
        decrementBlockCount: create.reducer((state, { payload }: PayloadAction<Record<string, number>>) => {
            Object.keys(payload).forEach((item) => {
                state.blocksCounts[item] -= payload[item];
            });
        }),
        resetBlocksCount: create.reducer((state) => {
            state.blocksCounts = { ...blocksCountsInitialState };
        }),
        setBlocksCounts: create.reducer((state, { payload }: PayloadAction<Record<string, number>>) => {
            state.blocksCounts = { ...blocksCountsInitialState, ...payload };
        }),
        setMaxBlocksCounts: create.reducer((state, { payload }: PayloadAction<number>) => {
            state.maxBlocksCounts = payload;
        }),
    }),
    selectors: {
        selectCustomerJourney: (customerJourney) => customerJourney,
    },
});

export const { incrementBlockCount, decrementBlockCount, resetBlocksCount, setBlocksCounts, setMaxBlocksCounts } =
    customerJourneySlice.actions;
export const { selectCustomerJourney } = customerJourneySlice.selectors;
